module.exports = __webpack_public_path__ + "58e3f28614bd52955b0e70885b1c1eb9.png";